import { LocationPros } from '../../../../types/baseTypes';
import { TenantConfigServices } from '../../../../types/tenantConfig';

// Services that do NOT imply opening hours when they are the only ones
export const NON_OPENING_HOURS_SERVICES = ['apartment', 'venue'] as const;

// Whitelist of services that imply opening hours relevance
export const OPENING_HOURS_RELEVANT_SERVICES: readonly string[] = [
  'rental',
  'storage',
  'p2p',
  'sup',
  'keys',
  'parcel',
  'voucher',
  'moreToCome',
] as const;

function isValidOpeningHours(selectedLocation: LocationPros | null): boolean {
  const oh = selectedLocation?.openingHours?.[0];
  const fromHour = oh?.times?.fromHour;
  const toHour = oh?.times?.toHour;
  return (
    Number.isFinite(fromHour) &&
    Number.isFinite(toHour) &&
    (fromHour as number) >= 0 &&
    (toHour as number) <= 24 &&
    (fromHour as number) < (toHour as number)
  );
}

/**
 * Decide whether opening hours should be displayed for a selected location.
 * - Prefer location-level services when present; otherwise, fall back to tenant-level services.
 * - Only show when there is at least one service other than apartment/venue (from whitelist above)
 *   AND the first openingHours entry is valid (0 <= from < to <= 24).
 */
export function shouldShowOpeningHours(
  selectedLocation: LocationPros | null,
  tenantServices: TenantConfigServices
): boolean {
  const locServices = selectedLocation?.services ?? [];
  const servicesToEvaluate: ReadonlyArray<string> =
    locServices.length > 0 ? locServices : tenantServices;

  const hasRelevantService = servicesToEvaluate?.some((s) =>
    OPENING_HOURS_RELEVANT_SERVICES.includes(s)
  );

  return Boolean(hasRelevantService && isValidOpeningHours(selectedLocation));
}

export default shouldShowOpeningHours;
